/** API route map: URLS.Controller.Departments */
export const Departments = {
      Name: 'Department/',
      AddDepartment: 'add-department',
      EditDepartment: 'update-department',
      DeleteDepartment: 'delete-department',
      GetAllDepartments: 'get-department',
      GetDropDownDepartments: 'get-departmentdropdown',
};
